<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="modal-header">
  <h4 class="modal-title">
    <span *ngIf="bankAccount && bankAccount.id">{{ 'BANKS.BANK_ACCOUNTS_FORM.EDIT' | translate }}</span>
    <span *ngIf="!bankAccount || !bankAccount.id">{{ 'BANKS.BANK_ACCOUNTS_FORM.ADD' | translate }}</span>
  </h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')">
  </button>
</div>

<ng-scrollbar class="modal-body ps">
  <form id="bank-accounts-form" (ngSubmit)="save()" [formGroup]="form" novalidate>
    <div class="row">
      <div class="col-sm-2">
        <app-company-select [parentFormGroup]="form" [passFormControlName]="'bankaccountable_id'"> </app-company-select>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.NAME' | translate }}</label>
          <input type="text" class="form-control" formControlName="name" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.ABBREVIATION' | translate }}</label>
          <input type="text" class="form-control" formControlName="abbreviation" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.ACCOUNT_NUMBER' | translate }}</label>
          <input type="text" class="form-control" formControlName="account_number" />
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.ADDRESS' | translate }}</label>
          <input type="text" class="form-control" formControlName="address" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.BENEFICIARY_NAME' | translate }}</label>
          <input type="text" class="form-control" formControlName="beneficiary_name" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.BIC' | translate }}</label>
          <input type="text" class="form-control" formControlName="bic" />
        </div>
      </div>

      <div class="col-sm-4">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.IBAN' | translate }}</label>
          <input type="text" class="form-control" formControlName="iban" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.SORT_CODE' | translate }}</label>
          <input type="text" class="form-control" formControlName="sort_code" />
        </div>
      </div>

      <div class="col-sm-2">
        <app-currency-select [passFormControlName]="'currency_id'" [parentFormGroup]="form"></app-currency-select>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.BALANCE' | translate }}</label>
          <input type="number" class="form-control" formControlName="balance" />
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.PAYMENT_CALCULATION_DATE' | translate }}</label>
          <app-date-picker [FormControl]="form.get('payment_calculation_date')"></app-date-picker>
        </div>
      </div>

      <div class="col-sm-2">
        <div class="form-group">
          <label>{{ 'BANKS.BANK_ACCOUNTS_FORM.LAST_BALANCE' | translate }}</label>
          <input type="number" class="form-control" formControlName="last_balance" />
        </div>
      </div>
    </div>
  </form>
</ng-scrollbar>

<div class="modal-footer d-flex justify-content-end">
  <button type="submit" class="btn btn-outline-dark btn-xs" form="bank-accounts-form" [disabled]="form.invalid">
    <ng-container>
      {{ 'BANKS.BANK_ACCOUNTS_FORM.SAVE' | translate }}
    </ng-container>
  </button>
</div>
